import React from "react";
import "../main.css";
import teachLogo from "../assets/teachla-logo.svg";
import PostsList from "../components/mainContent/PostsList";
//import CounterFrame from "../components/posts/FacialRecognition/CounterFrame";
import Timeline from "../components/posts/FacialRecognition/Timeline";
import AccuracyChart from "../components/posts/FacialRecognition/AccuracyChart";
import { VisibilityProvider } from "../components/mainContent/commonLogic";
import CategorizationGame from "../components/posts/FacialRecognition/CategorizationGame";

export default function FacialRecognition() {
  return (
    <VisibilityProvider>
      <FacialRecognitionContent />
    </VisibilityProvider>
  );
}

function FacialRecognitionContent() {
  return (
    <div className="posts">
      <PostsList content={FacialRecognitionInfo} />
    </div>
  );
}

const FacialRecognitionInfo = [
  {
    post: {
      profilePic: teachLogo,
      profilePicName: "Profile Picture - TeachLA Logo",
      header: "Case Study #3: Face Recognition",
      subheader: "Stay Tuned For More!",
      bodyText: [
        {
          body: (
            <p>
              Facial recognition technology is often used to identify crime
              suspects. However, research has shown that this technology is
              often inaccurate when identifying certain groups of people. A
              study by MIT found that facial recognition systems can be up to
              35% less accurate when identifying women or people of color. This
              can lead law enforcement to arrest or accuse the wrong people.
            </p>
          ),
        },
        {
          body: (
            <p className="bold">
              In this case study, we explore how humans’ biases when identifying
              people can affect how we train our facial recognition
              systems.{" "}
            </p>
          ),
        },
      ],
    },
  },

  {
    post: {
      profilePic: teachLogo,
      profilePicName: "Profile Picture - Frame 1",
      header: "Food Rating Game",
      subheader: "Understanding Bias Through Categorization",
      bodyText: [
        {
          body: <CategorizationGame />,
        },
      ],
    },
  },

  {
    post: {
      profilePic: teachLogo,
      profilePicName: "Profile Picture - Frame 2",
      header: "Frame 2",
      subheader: "Why Is This Important?",
      bodyText: [
        {
          body: (
            <p className="bold">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          ),
        },
        {
          body: (
            <p>
              Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur.
            </p>
          ),
        },
        {
          body: (
            <p>
              <mark className="bold">{`TODO: `} </mark>Excepteur sint occaecat
              cupidatat non proident, sunt in culpa qui officia deserunt mollit
              anim id est laborum.
            </p>
          ),
        },
      ],
    },
  },

  {
    post: {
      profilePic: teachLogo,
      profilePicName: "Profile Picture - Frame 3",
      header: "Facial Recognition Timeline",
      subheader: "Interactive Timeline",
      bodyText: [
        {
          body: <Timeline />,
        },
      ],
    },
  },

  {
    post: {
      profilePic: teachLogo,
      profilePicName: "Profile Picture - Frame 3b",
      header: "Accuracy of Face Recognition Technologies",
      subheader: "Hover to See Group Performance",
      bodyText: [
        {
          body: <AccuracyChart />,
        },
      ],
    },
  },

  {
    post: {
      profilePic: teachLogo,
      profilePicName: "Profile Picture - Frame 4",
      header: "Frame 4",
      subheader: "Why Is This Important?",
      bodyText: [
        {
          body: (
            <p className="bold">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          ),
        },
        {
          body: (
            <p>
              Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur.
            </p>
          ),
        },
        {
          body: (
            <p>
              <mark className="bold">{`TODO: `} </mark>Excepteur sint occaecat
              cupidatat non proident, sunt in culpa qui officia deserunt mollit
              anim id est laborum.
            </p>
          ),
        },
      ],
    },
  },

  {
    commentSection: {
      profilePic: teachLogo,
      profilePicName: "Teach Logo",
      followups: [
        {
          questionHeader: "Reflection Question 1:",
          question:
            "What are some privacy concerns that can arise with the increased use in facial recognition technology? What are some ways that such technology can help improve safety? Compare and contrast.",
          answers: [
            <p>
              For example, there are many concerns that having powerful facial
              recognition technology fall into the wrong hands, like corrupt
              governments or criminals, could lead to excess surveillance, loss
              of privacy, or easy stalking. On the flip side, using such
              technology carefully can help with law enforcement by easily
              identifying criminals in surveillance footage and finding missing
              people.
              <mark className="bold"></mark>
            </p>,
          ],
        },
      ],
    },
  },

  {
    commentSection: {
      profilePic: teachLogo,
      profilePicName: "Teach Logo",
      followups: [
        {
          questionHeader: "Reflection Question 2:",
          question:
            "In what ways can we reduce the bias present in facial recognition technology? Remember where such biases originate from.",
          answers: [
            <p>
              We could ensure that our models are trained on diverse datasets,
              continuously run tests on existing models that detect significant
              biases, and use these technologies with caution.
              <mark className="bold"></mark>
            </p>,
          ],
        },
      ],
    },
  },

  {
    commentSection: {
      profilePic: teachLogo,
      profilePicName: "Teach Logo",
      followups: [
        {
          questionHeader: "Reflection Question 3:",
          question:
            "What legal frameworks, standards, and guidelines are needed to safeguard individual rights and hold organizations accountable for the ethical use of facial recognition technology?",
          answers: [
            <p>
              For example, we could require facial recognition technology to
              undergo standardized testing to detect potential biases and
              require a human to approve its decisions in high-risk use cases,
              such as evidence in criminal court.
              <mark className="bold"></mark>
            </p>,
          ],
        },
      ],
    },
  },

  {
    post: {
      profilePic: teachLogo,
      profilePicName: "Profile Picture - Conclusion",
      header: "Conclusion",
      headerLink: true,
      linkTo: "conclusion",
      subheader: "Why Is This Important?",
      bodyText: [
        {
          body: (
            <p className="bold">
              The Consequences of Bias in Facial Recognition
            </p>
          ),
        },
        {
          body: (
            <p>
              Facial recognition technology has repeatedly been shown to exhibit
              various biases against certain groups, leading to real-world
              consequences such as wrongful identification of suspects or
              determining healthcare. To address these issues, researchers are
              actively working on debiasing facial recognition models as well as
              the data sets they rely on. This involves creating more balanced
              training data and adjusting algorithms so they learn to make
              accurate predictions.
            </p>
          ),
        },
        {
          body: <p></p>,
        },
      ],
    },
  },
];
